export default __webpack_public_path__ + "static/media/statcontrol.ffccf7f0.png";